import styled from 'styled-components'

export const MedicalRecordContainer = styled.div``

export const Header = styled.div`
  p:last-child {
    color: #898989;
  }
`

export const BoxInfo = styled.ul`
  background-color: #fffcb5;

  margin: 20px 0 30px;
  padding: 15px 20px;

  border-radius: 10px;

  li {
    display: flex;
    gap: 10px;

    span {
      display: flex;
      flex: none;
      align-items: center;
      justify-content: center;

      width: 24px;
      height: 24px;

      border-radius: 12px;

      background-color: #1f35b5;
      color: #fff;
    }
  }

  li + li {
    margin-top: 20px;
  }
`

export const Form = styled.div`
  width: 100%;
  padding-top: 0;
  margin-top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 50px;
`

export const Footer = styled.div`
  margin-top: 40px;

  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ButtonsWrapper = styled.div`
  button {
    width: 100%;
  }

  button + button {
    margin-top: 20px;
  }
`
